import { useEffect } from "react";
import { useNavigate } from "@/router";
import useCurrentUser from "@/hooks/useCurrentUser";
import { useFlags } from "@/hooks/useFeatureFlags";
import TasksTabContent from "../../_components/TasksTabContent";

export default function DepartmentTasksPage() {
  const navigate = useNavigate();
  const { user } = useCurrentUser();
  const userDepartment = user?.department;
  const flags = useFlags();
  const teamsEnabled = !!flags["m360-department-task-queue"];

  useEffect(() => {
    if (user && !userDepartment) {
      navigate("/tasks/my-tasks", { replace: true });
    }
  }, [user, userDepartment, navigate]);

  if (!userDepartment) {
    return null;
  }

  return (
    <TasksTabContent
      body={
        teamsEnabled
          ? `View and manage tasks tagged for the ${userDepartment} team`
          : `View and manage all tasks assigned to the ${userDepartment} department`
      }
      source="department_tasks_tab"
      queryOptions={
        teamsEnabled
          ? { fixedDepartment: userDepartment, useTeamTagForDepartment: true, showUnassignedChip: true }
          : { fixedDepartment: userDepartment }
      }
    />
  );
}
